<template>
  <div v-if="!isLoggedIn">
    <div class="d-flex align-items-center justify-content-center vh-100" style="background: #2563eb14">
      <div class="card text-center rounded-4 border-0 shadow-lg" style="width: 30rem;">
        <img src="../img/logo_trackpro.png" class="logo" alt="Logo">
        <div class="card-body mb-5">
          <h3 class="card-title fw-bold">{{ $t('general.pageTitle')}}</h3>
          <h6 class="card-subtitle mb-2 text-muted">{{ $t('general.subtitle')}}</h6>
          <form @submit.prevent="login" class="pt-4 mx-5">
            <div class="mb-3">
              <label for="login" class="form-label text-start col-12">{{ $t('user.loginName') }}</label>
              <input
                  :class="['form-control', v$.name.$errors.length ? 'is-invalid' : '']"
                  v-model="name"
                  autocomplete="off"
                  id="login"
                  type="text"
              />

              <div v-if="v$.name.$errors.length" class="invalid-feedback text-start">{{ $t('general.validator.required') }}</div>
            </div>

            <div class="mb-3">
              <label for="password" class="form-label text-start col-12">{{ $t('user.password') }}</label>
              <input
                  :class="['form-control', v$.password.$errors.length ? 'is-invalid' : '']"
                  type="password"
                  id="password"
                  v-model="password"
                  autocomplete="off"
              />
              <div v-if="v$.password.$error" class="invalid-feedback text-start">{{ $t('general.validator.required') }}</div>
            </div>
            <!--          <Captcha v-model="captcha" :disabled="loading" ref="captchainput" :maxretries="3"/>-->

            <div v-if="error" class="text-danger">{{ $t(error) }}</div>
            <div v-if="!loading">
              <button class="btn btn-primary col-12">{{ $t('user.login') }}</button>
            </div>
            <span v-else>
              <spinner variant="success" />
            </span>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./Login.scss" lang="scss" />
<script src="./Login.js" />